import React from 'react'

import { makeStyles } from '@material-ui/core/styles'

import headerImage from '../assets/images/logo.png'

const styles = (theme) => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    height: theme.spacing(32),
    justifyContent: 'center',
    margin: theme.spacing(2, 0),
    [theme.breakpoints.down('md')]: {
      height: theme.spacing(24),
    },
    [theme.breakpoints.down('xs')]: {
      height: theme.spacing(16),
    },
  },
  headerImage: {
    height: '100%',
  },
})
const useStyles = makeStyles(styles)

export default function ApplicationHeader() {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <img alt="logo" className={classes.headerImage} src={headerImage} />
    </div>
  )
}
